<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>工单管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="申诉状态"
                        prop="status">
            <el-select v-model="search.status"
                       multiple
                       placeholder="请选择申诉状态"
                       class="width-max"
                       clearable>
              <el-option v-for="item in appealStatusOptions"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工单ID"
                        prop="orderid">
            <el-input placeholder="请输入工单ID"
                      v-model="search.orderid"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="客户"
                        prop="customerid">
            <remote-select class="width-max"
                           clearable
                           placeholder="请输入客户名称/编号搜索"
                           v-model="search.customerid"
                           :query-request="getCustomerTable"
                           :find-request="getCustomerDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="项目"
                        prop="projectid">
            <remote-select class="width-max"
                           clearable
                           id-key="number"
                           label-key="name"
                           value-key="id"
                           placeholder="请输入项目 名称 进行搜索"
                           v-model="search.projectid"
                           :query-request="getProjectTable"
                           :find-request="getProjectDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="批次"
                        prop="batchid">
            <remote-select class="width-max"
                           clearable
                           id-key="number"
                           label-key="detail"
                           value-key="id"
                           placeholder="请输入批次 名称 进行搜索"
                           v-model="search.batchid"
                           :query-request="getBatchTable"
                           :find-request="getBatchDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="审核人"
                        prop="order_reviewer_id">
            <remote-select class="width-max"
                           clearable
                           id-key="id"
                           keyword-key="name"
                           label-key="name"
                           value-key="id"
                           placeholder="请输入管理员名称搜索"
                           v-model="search.order_reviewer_id"
                           :query-request="getPlatformUsersIndex"
                           :find-request="getPlatformUsersDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="申诉零工ID"
                        prop="userid">
            <el-input placeholder="请输入申诉零工ID"
                      v-model="search.userid"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="申诉发起时间"
                        prop="created_at">
            <el-date-picker v-model="search.created_at"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            align="center"
                            class="width-max"
                            clearable>
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit"
                     size="mini">搜索
          </el-button>
          <el-button @click="resetSearch()"
                     size="mini">重置
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <order-appeal-list-tabs active="appeal"></order-appeal-list-tabs>
      <div class="margin b15">
        <el-button type="primary"
                   size="mini"
                   @click="onExportSearch">按搜索结果导出
        </el-button>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%"
                ref="multipleTable">
        <el-table-column prop="id"
                         width="100"
                         label="ID">
        </el-table-column>
        <el-table-column prop="orderid"
                         width="116px"
                         label="工单ID">
          <template slot-scope="scope">
            <router-link :to="'/order/detail/'+scope.row.orderid"
                         style="text-decoration:none">
              <span style="color:rgb(88,157,248);">ORD{{ scope.row.orderid }}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="task_title"
                         width="150px"
                         label="任务名称">
        </el-table-column>
        <el-table-column label="项目名称/编号"
                         min-width="150px">
          <template slot-scope="scope">
            {{ scope.row.project_name }} / {{ scope.row.project_number }}
          </template>
        </el-table-column>
        <el-table-column prop="batch_name"
                         label="批次名称"
                         min-width="120px">
        </el-table-column>
        <el-table-column prop="provincename"
                         label="省份"
                         width="90px">
        </el-table-column>
        <el-table-column prop="cityname"
                         label="城市"
                         width="90px">
        </el-table-column>
        <el-table-column prop="areaname"
                         label="地区"
                         width="90px">
        </el-table-column>
        <el-table-column prop="order_reviewer_id"
                         label="最后审核人"
                         width="94px">
          <template slot-scope="scope">
            {{ scope.row.order_reviewer_name || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="status"
                         label="当前状态"
                         width="92px">
          <template slot-scope="scope">
            <el-tag :type="getAppealStatusTag(scope.row.status)"
                    size="mini">{{ getAppealStatusLabel(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="appeal_reason"
                         label="申诉原因"
                         min-width="160px"
                         show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="userid"
                         label="零工ID"
                         width="84px">
          <template slot-scope="scope">
            {{ scope.row.userid }}
          </template>
        </el-table-column>
        <el-table-column label="发起时间"
                         width="160px"
                         prop="created_at">
        </el-table-column>
        <el-table-column prop="audit_adminid"
                         label="申诉处理人"
                         width="94px">
          <template slot-scope="scope">
            {{ scope.row.audit_adminname || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="申诉处理时间"
                         width="160px"
                         prop="audited_at">
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="150px">
          <template slot-scope="scope">
            <button-gutter>
              <el-button type="primary"
                         size="mini"
                         v-if="canAuditOrderAppealBtn()"
                         :disabled="scope.row.status !== 1"
                         @click="goReview(scope.row)">处理
              </el-button><br>
              <router-link :to="`/order/appeal/detail/${scope.row.id}`"
                           target="_blank">
                <el-button type="success"
                           size="mini">申诉详情
                </el-button>
              </router-link>
            </button-gutter>
          </template>
        </el-table-column>

      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table, { removeEmptyParams } from '@core/mixins/table-v3'
import { NumberArray } from '@utils/common'
import { orderAppealMixin } from '@views/order/mixins/order-appeal.mixins.js'
import OrderAppealListTabs from '@views/order/components/OrderAppealListTabs.vue'

export default {
  components: {OrderAppealListTabs},
  mixins: [table, orderAppealMixin],
  data () {
    return {
      table: [],
      dialogBatchVisible: false,
      exportAsync: false,
      appealTimeRange: [],
      search: {
        status: [1],
        orderid: null,
        customerid: null,
        projectid: null,
        batchid: null,
        order_reviewer_id: null,
        userid: null,
        created_at: [],
      },
      searchFieldType: {
        customerid: Number,
        projectid: Number,
        batchid: Number,
        order_reviewer_id: Number,
        userid: Number,
        status: NumberArray,
      },
      exportHeader: [
        {key: 'id', text: 'ID'},
        {key: 'orderid', text: '工单ID', formatter: row => `ORD${row.orderid || ''}`},
        {key: 'task_title', text: '任务名称'},
        {key: 'project_name', text: '项目名称/编号', formatter: row => `${row.project_name || ''}/${row.project_number || ''}`},
        {key: 'batch_name', text: '批次名称', formatter: row => row.batch_name || ''},
        {key: 'provincename', text: '省份', formatter: row => row.provincename || ''},
        {key: 'cityname', text: '城市', formatter: row => row.cityname || ''},
        {key: 'areaname', text: '地区', formatter: row => row.areaname || ''},
        {key: 'order_reviewer_name', text: '最后审核人', formatter: row => `${row.order_reviewer_name}/${row.order_reviewer_id}` },
        {key: 'status', text: '当前状态', formatter: row => this.getAppealStatusLabel(row.status)},
        {key: 'appeal_reason', text: '申诉原因', formatter: row => row.appeal_reason || ''},
        {key: 'userid', text: '零工ID', formatter: row => row.userid || ''},
        {key: 'created_at', text: '发起时间', formatter: row => row.created_at || ''},
        {key: 'audit_adminname', text: '申诉处理人', formatter: row => row.audit_adminname || ''},
        {key: 'audited_at', text: '申诉处理时间', formatter: row => row.audited_at || ''},
      ],
    }
  },
  created () { },
  computed: {
    ...Vuex.mapState({
      options: state => state.order.options,
      users: state => state.login.user,
    }),
  },
  methods: {
    ...request.map([
      'getCustomerTable', 'getCustomerDetail',
      'getProjectTable', 'getProjectDetail', 'getBatchTable', 'getBatchDetail',
    ]),
    ...Vuex.mapActions(['getPlatformUsersIndex', 'getPlatformUsersDetail']),
    getAppealStatusTag (value) {
      const map = {1: 'warning', 2: 'success', 3: 'danger', 4: 'info', 5: 'info'}
      return map[value] || 'info'
    },
    getTableData (params) {
      return request.common('queryOrderAppealTableApi', params).then(res => {
        if (res && res.detail && Array.isArray(res.detail.data)) {
          res.detail.data = res.detail.data.map(item => ({
            ...item,
            project_info: `${item.project_name}/${item.project_number}`,
            status_label: this.getAppealStatusLabel(item.status)
          }))
        }
        return res
      })
    },
    getAppealStatusLabel (value) {
      const item = this.appealStatusOptions.find(i => i.value === value)
      return item ? item.label : '未知'
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: removeEmptyParams(_.cloneDeep(this.search)),
        getResponseData: (data) => {
          return data
        },
      })
    },
    // 跳转到工单申诉审核页（仅申诉中为可处理状态），新标签页打开
    goReview (row) {
      if (row.status !== 1) return
      const { href } = this.$router.resolve(`/order/appeal/review-order/${row.orderid}`)
      window.open(href, '_blank')
    },
    canAuditOrderAppealBtn () {
      // 具有审核的UI权限
      return filter.hasPermission(40012)
    },
  },
}
</script>

<style lang="scss"
       scoped>
</style>



// WEBPACK FOOTER //
// src/views/order/pages/OrderAppealTable.vue